export function isElementInViewport(el: Element) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
}

/**
 * keep find the element by id, if it's not in the view, scroll into the view.
 * used for pages rendered for long time
 * @param id element id
 * @param timeout after timeout, exit if the target element is still not in the view
 */
export function showElementInViewById(id: string, timeout = 3000) {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const startTime = new Date().getTime();
  const timeToCheckInMs = 100;
  let timer: number;
  const scrollIntoView = () => {
    if (new Date().getTime() - startTime > timeout) {
      window.clearInterval(timer);
      return;
    }

    const targetEl = document.getElementById(id);
    if (targetEl) {
      if (isElementInViewport(targetEl)) {
        window.clearInterval(timer);
        return;
      }
      targetEl.scrollIntoView();
    }
  };
  timer = window.setInterval(scrollIntoView, timeToCheckInMs);
  return timer;
}
